const PERMISSION_KEY= "search:#{@appConfigurationProperties.getIndex().getWidget()}";
const PAGE_URL = {
    WIDGET_DOCUMENT_SEARCH_PAGE: "/admin/search/widget-document-search"
}

export {PERMISSION_KEY, PAGE_URL}

